import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import BankInformation from '@features/supplier-onboarding/components/BankInformation';
import CapacityInformation from '@features/supplier-onboarding/components/CapacityInformation';
import DocumentUpload from '@features/supplier-onboarding/components/DocumentUpload';
import FactoryBasicInfo from '@features/supplier-onboarding/components/FactoryBasicInfo';
import ProductInformation from '@features/supplier-onboarding/components/ProductInformation';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { useSupplierInfo } from '@store/reducers/supplier-onboarding/OnboardingReducer';

import {
	getSupplierBankInfo,
	getSupplierDocuments,
	getSupplierInfo,
	getSupplierOnboardingStatus
} from '@services/supplierOnboardingService';

import { supplierWorkflowSteps } from '@/constants/constant';

const SupplierOnboarding = () => {
	const [activeStep, setActiveStep] = useState(supplierWorkflowSteps.FACTORY_BASIC_INFORMATION);
	const supplier = useSupplierInfo();
	const navigate = useNavigate();
	const { id } = useParams();
	const dispatch = useDispatch();

	const goBack = () => {
		navigate(-1);
	};

	useEffect(() => {
		(async () => {
			try {
				dispatch(openLoader());
				await Promise.all([
					dispatch(getSupplierOnboardingStatus(id)),
					dispatch(getSupplierInfo(id)),
					dispatch(getSupplierBankInfo(id)),
					dispatch(getSupplierDocuments(id))
				]);
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		})();
	}, []);

	const changeWorkflowStep = (index) => {
		let stepList = Object.keys(supplierWorkflowSteps);
		setActiveStep(supplierWorkflowSteps[stepList[index]]);
	};

	const renderWorkflowSteps = () => {
		return Object.keys(supplierWorkflowSteps)?.map((item, index) => {
			return (
				<li
					key={`step_${item}`}
					className={activeStep === supplierWorkflowSteps[item] ? 'active' : ''}
					onClick={() => changeWorkflowStep(index)}
				>
					<span className="step-number regular-12 weight-600">{index + 1}</span>
					{supplierWorkflowSteps[item]}
				</li>
			);
		});
	};

	const renderWorkflowPages = () => {
		switch (activeStep) {
			case supplierWorkflowSteps.FACTORY_BASIC_INFORMATION:
				return <FactoryBasicInfo setActiveStep={setActiveStep} />;
			case supplierWorkflowSteps.PRODUCT_INFORMATION:
				return <ProductInformation setActiveStep={setActiveStep} />;
			case supplierWorkflowSteps.DOCUMENT_UPLOAD:
				return <DocumentUpload setActiveStep={setActiveStep} />;
			case supplierWorkflowSteps.CAPACITY_INFORMATION:
				return <CapacityInformation setActiveStep={setActiveStep} />;
			case supplierWorkflowSteps.BANK_INFORMATION:
				return <BankInformation />;
			default:
				return <></>;
		}
	};

	return (
		<>
			<div className="top-header bg-white">
				<div className="page-title-area d-flex align-items-center">
					<button className="button text size32 p-0" onClick={goBack}>
						<img src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`} alt="back" />
					</button>
					<h1 className="semibold-16">{supplier?.name}</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp">
					<ul>{renderWorkflowSteps()}</ul>
				</div>
			</div>
			<div className="body-content supplier-bg-content bg-white ">
				<div className="supplier-basic-information">{renderWorkflowPages()}</div>
			</div>
		</>
	);
};

export default SupplierOnboarding;
